/**
 * @param {string} detailsUrl - Url za dohvaćanje detalja objekta
 * @param {function} $ - jQuery
 * @constructor
 */
function FacilityInfoProvider(detailsUrl, $) {
    validateType('string', detailsUrl,);
    validateType('function', $);

    var self = this;

    /**
     * @param {object} parameters
     * {
     *     objectId: {number},
     *     filters: (serijalizirana #SearchPrivateFilterForm)
     * }
     * @return {jqXHR}
     */
    self.getFacilityDetailsAsync = function (parameters) {
        // ne možemo raditi GET ajax request s partnerskih servisa
        return $.post(detailsUrl, parameters);
    };

    function validateType(expected, actual) {
        for (var i = 1; i < arguments.length; i++) {
            if (typeof arguments[i] !== expected) {
                throw new TypeError('expected a ' + expected + ', got ' + typeof arguments[i]);
            }
        }
    }
}

FacilityInfoProvider.prototype = {};

export default FacilityInfoProvider;
